import React from 'react';

import { ReactComponent as CloseIcon } from '../../../../assets/icons/close.svg';
import { colors } from '../../../../theme';
import { IAttachment } from '../../../../types/attachments';
import { getFileIcon } from '../../../../utils/fileTypeHelpers';
import { Attachment, RemoveAttachmentContainer } from './styled';

interface AttachmentItemProps {
    file: IAttachment;
    index: number;
    trimFilename?: boolean;
    getAttachmentUrl?: (file: IAttachment, index: number) => Promise<void>;
    removeAttachment?: (id: number) => void;
}

const AttachmentItem: React.FC<AttachmentItemProps> = ({
    file,
    index,
    trimFilename = false,
    getAttachmentUrl,
    removeAttachment
}) => {
    const fileName = file.name;

    if (!fileName) {
        return null;
    }
    if (!file.type) {
        return (
            <Attachment
                key={`attachment-${file.name}-${index}`}
                trim={trimFilename}
            >
                <span title={file.name}>{fileName}</span>
            </Attachment>
        );
    }
    return getAttachmentUrl ? (
        <Attachment
            key={`attachment-${file.name}-${index}`}
            onClick={() => getAttachmentUrl(file, index)}
            style={{ cursor: 'pointer' }}
            trim={trimFilename}
        >
            {getFileIcon(file.type)}
            <span title={file.name}>{fileName}</span>
            {removeAttachment && (
                <RemoveAttachmentContainer
                    onClick={() => removeAttachment(file.id)}
                >
                    <CloseIcon
                        width={10}
                        height={10}
                        style={{ color: colors.white }}
                    />
                </RemoveAttachmentContainer>
            )}
        </Attachment>
    ) : (
        <Attachment
            key={`attachment-${file.name}-${index}`}
            trim={trimFilename}
        >
            {getFileIcon(file.type)}
            <span title={file.name}>{fileName}</span>
            {removeAttachment && (
                <RemoveAttachmentContainer
                    onClick={() => removeAttachment(file.id)}
                >
                    <CloseIcon
                        width={10}
                        height={10}
                        style={{ color: colors.white }}
                    />
                </RemoveAttachmentContainer>
            )}
        </Attachment>
    );
};

export default AttachmentItem;
